// Image Utilities for API Content

/**
 * API'den gelen HTML içeriğindeki görsel yollarını düzeltir
 * @param {string} htmlContent - API'den gelen HTML içeriği
 * @returns {string} - Düzeltilmiş HTML içeriği
 */
export const fixImagePaths = (htmlContent) => {
  if (!htmlContent) return htmlContent;

  // Görsel yollarını düzelt
  let fixedContent = htmlContent;

  // Relative path'leri public URL'e çevir
  fixedContent = fixedContent.replace(
    /src="([^"]*\.(jpg|jpeg|png|gif|svg|webp))"/gi,
    (match, src) => {
      // Eğer zaten tam URL ise değiştirme
      if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('data:')) {
        return match;
      }
      
      // Eğer / ile başlıyorsa public URL'e ekle
      if (src.startsWith('/')) {
        return `src="${process.env.PUBLIC_URL}${src}"`;
      }
      
      // Eğer relative path ise public URL'e ekle
      return `src="${process.env.PUBLIC_URL}/${src}"`;
    }
  );

  // Background image'ları da düzelt
  fixedContent = fixedContent.replace(
    /background-image:\s*url\(['"]?([^'")\s]+)['"]?\)/gi,
    (match, url) => {
      // Eğer zaten tam URL ise değiştirme
      if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
        return match;
      }
      
      // Eğer / ile başlıyorsa public URL'e ekle
      if (url.startsWith('/')) {
        return `background-image: url("${process.env.PUBLIC_URL}${url}")`;
      }
      
      // Eğer relative path ise public URL'e ekle
      return `background-image: url("${process.env.PUBLIC_URL}/${url}")`;
    }
  );

  return fixedContent;
};

/**
 * Görsel yükleme hatası durumunda fallback görsel gösterir
 * @param {Event} event - Error event
 * @param {string} fallbackSrc - Fallback görsel yolu
 */
export const handleImageError = (event, fallbackSrc = '/logo.jpg') => {
  const img = event.target;
  if (img.src !== fallbackSrc) {
    img.src = process.env.PUBLIC_URL + fallbackSrc;
  }
};

/**
 * Görsel yükleme durumunu kontrol eder
 * @param {string} src - Görsel yolu
 * @returns {Promise<boolean>} - Görsel yüklenebilir mi?
 */
export const checkImageExists = (src) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = src;
  });
};

/**
 * API'den gelen HTML içeriğini güvenli hale getirir
 * @param {string} htmlContent - API'den gelen HTML içeriği
 * @returns {string} - Güvenli HTML içeriği
 */
export const sanitizeHtmlContent = (htmlContent) => {
  if (!htmlContent) return htmlContent;

  // Görsel yollarını düzelt
  let sanitizedContent = fixImagePaths(htmlContent);

  // Görsel elementlerine error handler ekle
  sanitizedContent = sanitizedContent.replace(
    /<img([^>]*)>/gi,
    (match, attributes) => {
      // Eğer zaten onerror varsa değiştirme
      if (attributes.includes('onerror=')) {
        return match;
      }
      
      // onerror attribute'u ekle
      return `<img${attributes} onerror="this.onerror=null; this.src='${process.env.PUBLIC_URL}/logo.jpg';" />`;
    }
  );

  return sanitizedContent;
}; 